const CSS_VAR_PREFIX = '--Polaris-RangeSlider-';

export { CSS_VAR_PREFIX };
